import { render, staticRenderFns } from "./DialogNovoTipo.vue?vue&type=template&id=6f51d36e"
import script from "./DialogNovoTipo.vue?vue&type=script&lang=js"
export * from "./DialogNovoTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports